import { SubmitHandler, useForm } from "react-hook-form"
import { login, useAuthDispatch } from "../../context/auth"

import { APIError } from "../../sdk/api"
import ErrorToast from "../miscellaneous/error-toast"
import IconAction from "../universal/icon-action"
import Input from "../fields/input"
import React from "react"
import { toast } from "react-toastify/unstyled"
import { useAPIState } from "../../context/client"
import { useQueryParams } from "../../hooks/use-url-search-params"
import { useStorage } from "../../hooks/use-storage"
import { useTranslation } from "react-i18next"

type LoginFormProps = {
    onSuccess?: () => void
    setEmailAddress?: (email: string) => void
}

type FormValues = {
    login: string
    password: string
}

const LoginForm = ({ onSuccess, setEmailAddress }: LoginFormProps) => {
    const { t } = useTranslation("shared")
    const email = useAPIState(s => s.email)

    const { handleSubmit, control } = useForm<FormValues>({
        mode: "onTouched",
        defaultValues: {
            login: email || "",
            password: "",
        },
        context: undefined,
        criteriaMode: "firstError",
        shouldFocusError: true,
    })

    const dispatch = useAuthDispatch()

    const [, setGuestCustomer] = useStorage("guest_customer")
    const [, setPersistedState] = useStorage("checkout_state")

    const { getQueryParam } = useQueryParams()
    const return_url = getQueryParam("return_url")

    const onSubmit: SubmitHandler<FormValues> = async values => {
        const body = {
            login: values.login,
            password: values.password,
        }

        await login(dispatch, body, {
            onSuccess: () => {
                setGuestCustomer(null)
                setPersistedState(null)
                toast.dismiss("credentials_invalid")
                onSuccess && onSuccess()
            },
            onError: err => {
                const error = err as APIError
                if (error.status === 401)
                    // @ts-ignore
                    return toast.error(<ErrorToast error={{ code: "credentials_invalid" }} />, {
                        toastId: "credentials_invalid",
                    })
                toast.error(<ErrorToast error={error} />, { toastId: error.code })
            },
        })
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} name="login-form" noValidate>
            <Input
                rules={{ required: { value: true, message: t("form_error_required") } }}
                control={control}
                type="text"
                name="login"
                label={t(`login_form_label_email${return_url.includes("partner") ? "_partner" : ""}`)}
                autocomplete="email"
                onChange={setEmailAddress || undefined}
                required
            />
            <Input
                rules={{ required: { value: true, message: t("form_error_required") } }}
                control={control}
                type="password"
                name="password"
                label={t("login_form_label_password")}
                autocomplete="current-password"
                required
            />
            <IconAction submit button fullWidth title={t("login_form_submit")} />
        </form>
    )
}

export default LoginForm
